module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "playground"
  }, [_c('h3', [_vm._v("Playground")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "project-item"
  }, [_c('p', {
    staticClass: "project-desc"
  }, [_vm._v("Am working on putting up all my experiments and hacks.")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "playground-img"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f3387a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Playground.vue
// module id = 53
// module chunks = 0